export const test = {
  currentPage: 1,
  itemsPerPage: 10,
  isFetching: false,
  fetchingErrorMessage: '',
  items: [],
  filter: {
    settingId: '',
    enabled: '',
  },
};

export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  isFetching: false,
  fetchingErrorMessage: '',
  items: [],
  filter: {
    settingId: '',
    enabled: '',
  },
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/globalSettings.state.js
 **/